import React, { forwardRef } from 'react';

import { CustomContentProps, SnackbarContent } from 'notistack';
import { styled } from '@mui/material/styles';

import Card from '@mui/material/Card';

import NotificationsIcon from '@mui/icons-material/Notifications';

const StyledSnackbarContent = styled(SnackbarContent)(() => ({
  '@media (min-width:600px)': {
    minWidth: '344px !important',
  },
}));

interface NotificationSnackProps extends CustomContentProps {
  allowDownload?: boolean;
}

const NotificationSnack = forwardRef<HTMLDivElement, NotificationSnackProps>(
  ({ id, ...props }, ref) => {
    return (
      <StyledSnackbarContent ref={ref}>
        <Card className={'notification-snack'}>
          <div className="d-flex justify-content-start align-items-center mb-2">
            <NotificationsIcon className="" />
            <h5 className="m-0 p-0">Notification</h5>
          </div>
          <p className="m-0 p-0 ps-4">{props.message}</p>
        </Card>
      </StyledSnackbarContent>
    );
  },
);

NotificationSnack.displayName = 'ReportComplete';

export default NotificationSnack;
